export default "__VITE_ASSET__qZB2q3bU__"